'use client';

import { useAtomValue } from 'jotai';

import ContentfulRichText from '@flipster/features/src/shared/contentful-rich-text';
import { Styles, css } from '@flipster/styled-system/css';
import { flex } from '@flipster/styled-system/patterns';

import { glossaryTermAtom } from '../jotai';
import ShareTermButton from './share-term-button';

const GlossaryTermArticle = ({ css: cssProp }: { css: Styles }) => {
  const glossaryTerm = useAtomValue(glossaryTermAtom);
  if (!glossaryTerm) return null;

  return (
    <article className={css(cssProp)}>
      <h1
        className={flex({
          textStyle: 'Legacy/H2',
          pb: 17,
          mb: 23,
          color: 'legacy.gray.e',
          borderBottomWidth: '1px',
          borderBottomStyle: 'solid',
          borderColor: 'legacy.gray.4',
          tablet: {
            textStyle: 'Legacy/H1',
            alignItems: 'center',
            pb: 0,
            mb: 50,
            color: 'white',
            borderBottom: 'none',
          },
        })}
      >
        {glossaryTerm.name}
        <ShareTermButton glossaryTerm={glossaryTerm} />
      </h1>

      {glossaryTerm.description && (
        <ContentfulRichText richTextDocument={glossaryTerm.description} startHeadingLevel={2} />
      )}
    </article>
  );
};

export default GlossaryTermArticle;
